export const FREEMIUM_POTENTIAL_SEARCH_CREDITS = 5;
export const FREEMIUM_LINKEDIN_POSTING_CREDITS = 5;
export const FREEMIUM_CANDIDATE_DATABASE_CREDITS = 10;

export const PROFESSIONAL_POTENTIAL_SEARCH_CREDITS = 100;
